var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(this.examtitle))]),_c('v-card-text',[_c('b-row',[_c('b-col',{attrs:{"cols":"9"}},_vm._l((_vm.students),function(student,index){return _c('Attemp',{key:student.key,staticStyle:{"margin-bottom":"10px"},attrs:{"student":student.firstname +
                  ' ' +
                  student.middlename +
                  ' ' +
                  student.lastname,"id":student.key,"assignment":_vm.exampath,"index":index + 1}})}),1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }